import * as e from "react";
import s from "../lib/SSRBase.es.js";
import t from "../defs/PauseCircle.es.js";
const r = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(s, { ref: a, ...o, weights: t }));
r.displayName = "PauseCircleIcon";
const m = r;
export {
  m as PauseCircle,
  r as PauseCircleIcon
};
